import axios from 'axios';
import {
  CHOOSE_GROUP_SLUG,
  FETCH_GALLERIES_FAILURE,
  FETCH_GALLERIES_REQUEST,
  FETCH_GALLERIES_SUCCESS,
  FETCH_GALLERY_FAILURE,
  FETCH_GALLERY_REQUEST,
  FETCH_GALLERY_SUCCESS,
  FETCH_VIDEO_SLUG_FAILURE,
  FETCH_VIDEO_SLUG_REQUEST,
  FETCH_VIDEO_SLUG_SUCCESS,
  FETCH_VIDEOS_FAILURE,
  FETCH_VIDEOS_REQUEST,
  FETCH_VIDEOS_SUCCESS,
} from './actionTypes';

export function getGallery(slug) {
  return dispatch => {
    dispatch({ type: FETCH_GALLERY_REQUEST });
    axios({
      url: `${process.env.GATSBY_API_URL}/gallery?slug=${slug}`,
      method: 'get',
    })
      .then(response => {
        dispatch({ type: FETCH_GALLERY_SUCCESS, payload: response.data });
      })
      .catch(error => {
        dispatch({ type: FETCH_GALLERY_FAILURE, payload: error });
      });
  };
}

export const ChooseGroupSlug = slug => dispatch => {
  dispatch({ type: CHOOSE_GROUP_SLUG, payload: slug });
};

export function getAllGallerie() {
  return dispatch => {
    dispatch({ type: FETCH_GALLERIES_REQUEST });
    axios({
      url: `${process.env.GATSBY_API_URL}/gallery`,
      method: 'get',
    })
      .then(response => {
        dispatch({ type: FETCH_GALLERIES_SUCCESS, payload: response.data });
      })
      .catch(error => {
        dispatch({ type: FETCH_GALLERIES_FAILURE, payload: error });
      });
  };
}

export function getVideoBySlug(slug) {
  return dispatch => {
    dispatch({ type: FETCH_VIDEO_SLUG_REQUEST });
    axios({
      url: `${process.env.GATSBY_API_URL}/video/videos?slug=${slug}`,
      method: 'get',
    })
      .then(response => {
        dispatch({ type: FETCH_VIDEO_SLUG_SUCCESS, payload: response.data });
      })
      .catch(error => {
        dispatch({ type: FETCH_VIDEO_SLUG_FAILURE, payload: error });
      });
  };
}

export function getAllVideos() {
  return dispatch => {
    dispatch({ type: FETCH_VIDEOS_REQUEST });
    return axios({
      url: `${process.env.GATSBY_API_URL}/video/videos`,
      method: 'get',
    })
      .then(response => {
        dispatch({ type: FETCH_VIDEOS_SUCCESS, payload: response.data });
      })
      .catch(error => {
        dispatch({ type: FETCH_VIDEOS_FAILURE, payload: error });
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/GallerieAction.js